import { useMemo } from "react";
import { RegisterData } from "@/modules/types/auth";
import { authService } from "@/modules/services/auth/authService";
import { useAuthStore } from "@/modules/store/authStore";
import { apiClient } from "@/lib/api/api-client";

export function useAuth() {
  const { token, setToken, setRefreshToken, setExpired, logoutUser } =
    useAuthStore();

  const isAuthenticated = useMemo(() => {
    return !!token;
  }, [token]);

  const login = async (
    email: string,
    password: string,
    isSaveLogin?: boolean,
    provider?: string,
    providerId?: string,
    fullName?: string
  ) => {
    const response = await authService.login({
      email,
      password,
      isSaveLogin,
      provider,
      providerId,
      fullName,
    });
    apiClient.setToken(response.token);
    setToken({
      token: response.token,
      expired: response.expiredAt,
    });
    setRefreshToken({
      token: response.refreshToken,
      expired: response.expiredAt + 3600,
    });
    setExpired(response.expiredAt);
    return response;
  };

  const register = async (userData: RegisterData) => {
    const response = await authService.register(userData);
    apiClient.setToken(response.token);
    setToken({
      token: response.token,
      expired: response.expiredAt,
    });
    setRefreshToken({
      token: response.refreshToken,
      expired: response.expiredAt + 3600,
    });
    setExpired(response.expiredAt);
    return response;
  };

  const logout = async () => {
    await authService.logout();
    apiClient.setToken(null);
    logoutUser();
  };

  return {
    login,
    register,
    logout,
    isAuthenticated,
  };
}
